<template>
    <v-container fluid class="headermargin">
        <v-col cols="12">
            <v-row>
                <v-col cols="6" lg="6" md="12" sm="12" class="px-0">
                    <v-text-field
                        solo
                        elevation="0"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-col>
        <v-data-table
            :headers="headers"
            :items="users"
            :items-per-page="10"
            :search="search"
            class="elevation-1 mt-6"
        >
            <template v-slot:[`item.userEdit`]="{ item, on, attrs }">
                <v-btn
                    @click="openUser(item)"
                    depressed
                    class="primary--text white float-right"
                    v-bind="attrs"
                    v-on="on"
                    >Open<v-icon>mdi-chevron-right</v-icon></v-btn
                >
            </template>
        </v-data-table>
        <!-- User panel -->
        <v-navigation-drawer v-model="dialog" fixed right width="600">
            <!-- OVERLAY FOR UPDATE USER -->
            <v-overlay :value="updateUser">
                <v-col cols="12" class="d-flex flex-column align-center">
                    <v-progress-circular
                        indeterminate
                        class="mb-4"
                        size="64"
                    ></v-progress-circular>
                    <div class="text-center">Updating user, please wait...</div>
                </v-col>
            </v-overlay>
            <!-- OVERLAY FOR ACTIVATE USER -->
            <v-overlay :value="activateUser" opacity="0.85">
                <v-col
                    cols="12"
                    class="d-flex flex-column align-center"
                >
                    <div
                        class="
                            text-h4
                            error--text
                            font-weight-bold
                            pb-4
                        "
                    >
                        Warning!
                    </div>
                    <div class="body-1 pb-8">
                        Are you sure you want to activate the user {{ user.userFirstName + ' ' + user.userLastName }}
                    </div>
                    <v-row>
                        <v-col cols="6">
                            <v-btn
                                block
                                class="darkgrey"
                                @click="activateUser = false"
                                >Cancel</v-btn
                            >
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                block
                                class="primary"
                                @click="activateAdminUser()"
                                :loading="loading"
                                :disabled="loading"
                                >ACTIVATE</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-col>
            </v-overlay>
            <v-toolbar dark class="darkgrey mb-4">
                <v-row class="d-flex align-center justify-space-between pa-4">
                    <div class="text-h4 font-weight-light white--text">
                        {{ user.userFirstName }} {{ user.userLastName }}
                    </div>
                    <v-btn icon @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-row>
            </v-toolbar>
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td class="font-weight-bold text-left">Id:</td>
                            <td class="text-right">{{ user.userId }}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold text-left">Account Type:</td>
                            <td class="text-right">
                                {{ user.userType }}
                            </td>
                        </tr>
                        <tr v-if="user.userType === 'Admin'">
                            <td class="font-weight-bold text-left">Status:</td>
                            <td v-if="!user.userVerified" class="error--text text-right">
                                Not Verified
                            </td>
                            <td v-else class="success--text text-right">
                                Verified
                            </td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold text-left">User:</td>
                            <td class="text-right">
                                {{ user.userFirstName }} {{ user.userLastName }}
                            </td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold text-left">Email:</td>
                            <td class="text-right">{{ user.userEmail }}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold text-left">Telephone:</td>
                            <td class="text-right">{{ user.userTelephone }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-spacer class="py-6"></v-spacer>
            <v-row class="ma-4">
                <v-btn
                    v-if="user.userType === 'Admin' && !user.userVerified"
                    block
                    large
                    class="primary white--text"
                    @click="activateUser = true"
                    >ACTIVATE USER</v-btn
                >
                <v-btn
                    v-if="user.userType === 'Admin' && user.userVerified"
                    block
                    large
                    disabled
                    >ACTIVATE USER</v-btn
                >
            </v-row>
        </v-navigation-drawer>
    </v-container>
</template>

<script>
export default {
    name: "Users",
    data: () => ({
        activeUserId: "",
        activateUser: false,
        dialog: false,
        firebaseUser: {
            disabled: false,
        },
        headers: [
            { text: "User Type", value: "userType", class: "lightgrey" },
            { text: "First Name", value: "userFirstName", class: "lightgrey" },
            { text: "Last Name", value: "userLastName", class: "lightgrey" },
            { text: "Email", value: "userEmail", class: "lightgrey" },
            { text: "Telephone", value: "userTelephone", class: "lightgrey" },
            { text: "", value: "userEdit", class: "lightgrey text-end" },
        ],
        loader: false,
        loading: false,
        search: "",
        updateUser: false,
        user: {
            business: {
                name: "",
            },
            isDisabled: '',
        },
        users: [],
        userDisabled: false,
    }),
    methods: {
        getAllUsers() {
            let t = this;
            t.$firebase.db
                .collection("users")
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        t.users.push(doc.data());
                    });
                });
        },
        openUser(item) {
            let t = this;
            t.dialog = true;
            t.activeUserId = item.userId;
            t.getUser();
        },
        getUser() {
            let t = this;
            t.$firebase.db
                .collection("users")
                .doc(t.activeUserId)
                .onSnapshot((doc) => {
                    const user = doc.data();
                    user.id = doc.id;
                    t.user = {};
                    t.user = user;
                });
        },
        activateAdminUser() {
            let t = this
            t.$firebase.db.collection("users").doc(t.user.id).update({ userVerified: true })
            t.activateUser = false
        }
    },
    mounted() {
        let t = this;
        t.getAllUsers();
    },
};
</script>